import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import type { AutoCheckoutAlert } from "@/hooks/useRecentAutoCheckouts";
import { cn } from "@/lib/utils";

export function AdminDashboardAutoCheckouts({
  items,
  className,
}: {
  items: AutoCheckoutAlert[];
  className?: string;
}) {
  if (items.length === 0) {
    return (
      <div
        className={cn(
          "rounded-lg border border-border bg-card p-4 text-center text-sm text-muted-foreground",
          className,
        )}
      >
        Brak automatycznych wylogowań z ostatnich 7 dni
      </div>
    );
  }

  return (
    <div className={cn("rounded-lg border border-amber-500/40 bg-amber-50/60 dark:bg-amber-950/20 p-4", className)}>
      <h3 className="flex items-center gap-2 text-sm font-semibold text-amber-800 dark:text-amber-200 mb-3">
        <LogOut className="h-4 w-4" />
        Automatyczne wylogowania
      </h3>
      <ul className="space-y-2">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/workers/${item.userId}?tab=activity-log`}
              className="block rounded border border-border bg-background p-2 text-sm hover:bg-accent transition-colors"
            >
              <span className="font-medium">{item.workerName}</span>
              <span className="text-muted-foreground"> · {item.locationAddress.split(",")[0]}</span>
              <span className="block text-xs text-muted-foreground mt-0.5">
                {item.closeReasonLabel}
                {item.distanceMeters != null ? ` · ${item.distanceMeters} m od obiektu` : ""}
                {item.endedAt
                  ? ` · ${new Date(item.endedAt).toLocaleString("pl-PL", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}`
                  : ""}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
